import { connect } from 'react-redux';
import { isEmpty, get } from 'lodash';
import { compose, withProps, branch, renderNothing, withHandlers } from 'recompose';

import { reassignSaleItem } from '../actions';
import { getIsRentalShop, getShopBarbers, isBrandViewActive } from '../../../auth/selectors';
import ReassignButton from './ReassignButton';
import withToggle from '../../../common/hoc/withToggle';
import withNotifications from '../../../common/withNotifications';
import { isGiftCardItem, canReassign } from '../Summary/utils';
import { t } from '../../../../modules/infra/i18n';

export default compose(
  withToggle(),
  withNotifications,
  connect(
    (state, props) => {
      const shopId = get(props, 'selected.shopId') || get(props, 'selected.items[0].shopId');
      const barbers = getShopBarbers(state, shopId).filter(barber => barber.id !== get(props, 'selected.barber.id'));
      return {
        barbers,
        shopId: props.selected.shopId,
        shouldShowReassign: isEmpty(props.selected) ||
          (!getIsRentalShop(state) && !isEmpty(barbers)) ||
          isBrandViewActive(state),
      };
    },
    { reassignSaleItem }
  ),
  withHandlers({
    reassign: props => barber => () => {
      props.reassignSaleItem(props.shopId, props.selected.id, props.selected.parentId, barber).then(() => {
        props.addNotification({
          title: t('common:notifications.success_title_alt'),
          level: 'success',
          message: t('register:summary.reassign_success.message'),
        });
      });
      props.afterReassign();
      props.off();
    },
  }),
  branch(
    props => !props.shouldShowReassign,
    renderNothing,
  ),
  withProps(props => ({
    disabled:
      isEmpty(props.selected)
      || isGiftCardItem(props.selected)
      || props.isLoading
      || !canReassign(props.selected),
  })),
)(ReassignButton);
